var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cog",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_settings_24px",
    d: "M20.793,13.529a7.963,7.963,0,0,0,.076-1.029,7.963,7.963,0,0,0-.076-1.029l2.278-1.732a.52.52,0,0,0,.13-.672L21.042,5.434a.55.55,0,0,0-.658-.231L17.7,6.253a7.943,7.943,0,0,0-1.824-1.029l-.41-2.783A.522.522,0,0,0,14.932,2H10.614a.522.522,0,0,0-.529.441l-.41,2.783A8.352,8.352,0,0,0,7.851,6.253L5.163,5.2a.533.533,0,0,0-.658.231L2.346,9.067a.508.508,0,0,0,.13.672l2.278,1.732A8.1,8.1,0,0,0,4.677,12.5a8.1,8.1,0,0,0,.076,1.029L2.475,15.262a.52.52,0,0,0-.13.672L4.5,19.567a.55.55,0,0,0,.658.231l2.688-1.05a7.943,7.943,0,0,0,1.824,1.029l.41,2.782a.522.522,0,0,0,.529.441h4.318a.522.522,0,0,0,.529-.441l.41-2.782A8.352,8.352,0,0,0,17.7,18.748l2.688,1.05a.533.533,0,0,0,.658-.231L23.2,15.934a.52.52,0,0,0-.13-.672Zm-8.02,2.646A3.676,3.676,0,1,1,16.551,12.5,3.732,3.732,0,0,1,12.773,16.175Z",
    transform: "translate(-2.271 -2)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.f35cf5f5659f8667d09e7a261ebd938c.svg";
export { ForwardRef as ReactComponent };